export const frozenFoodsLinks = [
  {
    name: 'Welcome',
    link: '/frozen-foods-welcome'
  },
  {
    name: 'Pickup Information',
    link: '/frozen-foods-pickup-information'
  },
  {
    name: 'Item Information',
    link: '/frozen-foods-item-information'
  },
  {
    name: 'Pickup Options',
    link: '/frozen-foods-rates-options'
  },

  {
    name: 'Summary',
    link: '/frozen-foods-summary'
  },
  {
    name: 'Payment',
    link: '/frozen-foods-payment'
  },
  {
    name: 'Confirmation',
    link: '/frozen-foods-order-confirmation'
  }
];
